module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-14.0d3d05e4.png";